/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {TreeManager} from './tree-manager';
import {TreeNode} from './tree-node';
import {BehaviorSubject} from 'rxjs';

export class DataTreeManager extends TreeManager {

  constructor(data: TreeNode) {
    super();
    this.loader = new BehaviorSubject(data);
    this.root = data;
  }

  public load(data: TreeNode) {
    this.loader.next(data);
    this.root = data;
  }
}
